import React from 'react';
import ServicesEditTemplate from './services-edit-template'

const CareGiverService = () => {
    return <ServicesEditTemplate doc="care_giver" service="Care Giver" />;
};

export default CareGiverService;